import { LocationQueryRaw } from 'vue-router'
import router from '@/router/index'
import { dayjs } from '@/plugins/dayjs'

const startDateQueryKeys = ['sd'] as const
const endDateQueryKeys = ['ed'] as const

type StartDateQueryKeys = typeof startDateQueryKeys[number]
type EndDateQueryKeys = typeof endDateQueryKeys[number]

type StartDateQueryItem = Record<StartDateQueryKeys, string>
type EndDateQueryItem = Record<EndDateQueryKeys, string>

export const getStartDateQuery = (): string => {
  const queryClone = { ...router.currentRoute.value.query }
  return startDateQueryKeys[0] in queryClone ? (queryClone as StartDateQueryItem)[startDateQueryKeys[0]] : ''
}
export const getEndDateQuery = (): string => {
  const queryClone = { ...router.currentRoute.value.query }
  return endDateQueryKeys[0] in queryClone ? (queryClone as EndDateQueryItem)[endDateQueryKeys[0]] : ''
}

const toStartDateQuery = (date: Date): StartDateQueryItem => {
  const strDate = dayjs(date).format('YYYYMMDD')
  return { [startDateQueryKeys[0]]: strDate }
}
const toEndDateQuery = (date: Date): EndDateQueryItem => {
  const strDate = dayjs(date).format('YYYYMMDD')
  return { [endDateQueryKeys[0]]: strDate }
}

export const addStartDateQuery = (date?: Date): LocationQueryRaw => {
  const queryClone = { ...router.currentRoute.value.query }
  if (date instanceof Date) {
    return { ...queryClone, ...toStartDateQuery(date) }
  } else {
    delete queryClone[startDateQueryKeys[0]]
    return queryClone
  }
}
export const addEndDateQuery = (date?: Date): LocationQueryRaw => {
  const queryClone = { ...router.currentRoute.value.query }
  if (date instanceof Date) {
    return { ...queryClone, ...toEndDateQuery(date) }
  } else {
    delete queryClone[endDateQueryKeys[0]]
    return queryClone
  }
}
